export default {
  website: {
    website_1001:
      '微吼-直播,网络直播,视频直播,在线教育平台,视频直播平台,网络直播系统,中国最大的网络直播互动平台',
    website_1002:
      '微吼,微吼直播,在线直播,视频会议,远程培训,直播软件,直播,现场直播,网络直播,视频直播,网络教学平台,视频会议软件,在线教育平台,教育在线互动平台,网络视频直播平台,活动策划直播,多屏互动浏览',
    website_1003:
      '微吼，全球在线商务活动平台专业服务提供商，最大的网络直播平台；提供网络直播、在线教育和视频会议等服务，支持多屏互动浏览；租用热线:400-888-9970。',
    website_1004: '按ESC可退出全屏模式'
  },
  common: {
    common_1001: '加载中...',
    common_1002: '桌面共享容器',
    common_1003: '邀请',
    common_1004: '问答',
    common_1005: '支付成功',
    common_1006: '请输入手机号/邮箱/工号',
    common_1007: '检测类型和活动观看限制类型不一致',
    common_1008: '私聊',
    common_1009: '简体中文',
    common_1010: '确认',
    common_1011: '向右拖动滑块填充拼图',
    common_1012: '开始时间',
    common_1013: '在线人数',
    common_1014: '万',
    common_1015: '亿',
    common_1016: '万亿',
    common_1017: '活动简介',
    common_1018: '直播',
    common_1019: '预告',
    common_1020: '结束',
    common_1021: '回放',
    common_1022: '定时',
    common_1023: '无延迟',
    common_1024: '点播',
    common_1025: '副标题',
    common_1026: '音频',
    common_1027: '视频',
    common_1028: '互动',
    common_1029: '分组',
    common_1030: '点击',
    common_1031: '预约人数',
    common_1032: '观看人数',
    common_1033: '我知道了',
    common_1034: '保存成功',
    common_1035: '重新加载',
    common_1036: '竖屏',
    common_1037: '介绍'
  },
  player: {
    player_1001: '热度',
    player_1002: '原画',
    player_1003: '高清',
    player_1004: '标清',
    player_1005: '超清',
    player_1006: '音频',
    player_1007: '倍速',
    player_1008: '切换',
    player_1009: '已为您切换到',
    player_1010: '内容即将呈现...',
    player_1011: '你已经进入横屏模式',
    player_1012: '上次观看至{n}，已为您自动续播',
    player_1013: '立即观看',
    player_1014: '语音播放中...',
    player_1015: '已为您切换到{n}倍速',
    player_1016: '重新播放',
    player_1017: '直播已结束',
    player_1018: '直播已开始，请观看直播吧',
    player_1019: '倍速设置失败',
    player_1020: '清晰度设置失败',
    player_1021: '暂停',
    player_1022: '播放',
    player_1023: '调整播放时间失败',
    player_1024: '设置当前时间失败,请稍后重试',
    player_1025: '正常',
    player_1026: '直播回放中',
    player_1027: '现在没有进行彩排，下次再来参与吧'
  },
  appointment: {
    appointment_1001: '白名单验证',
    appointment_1002: '输入手机号/邮箱/工号',
    appointment_1003: '活动不存在',
    appointment_1004: '您已预约成功',
    appointment_1005: '直播当天请访问此页面观看直播',
    appointment_1006: '预约成功',
    appointment_1007: '您的信息不在白名单中',
    appointment_1008: '没有白名单',
    appointment_1009: '输入密码',
    appointment_1010: '付费',
    appointment_1011: '邀请码',
    appointment_1012: '您可以免费观看{n}分钟，完整观看请',
    appointment_1013: '试看结束，观看完整视频',
    appointment_1014: '重新试看',
    appointment_1015: '距离开播',
    appointment_1016: '已开播',
    appointment_1017: '立即预约',
    appointment_1018: '已预约{n}人',
    appointment_1019: '这里空空如也',
    appointment_1020: '观看验证',
    appointment_1021: '密码错误',
    appointment_1022: '请输入密码',
    appointment_1023: '付费{n}观看',
    appointment_1024: '请输入邀请码',
    appointment_1025: '观看验证',
    appointment_1026: '天',
    appointment_1027: '时',
    appointment_1028: '分',
    appointment_1029: '秒',
    appointment_1030: '活动主办方设置了试看',
    appointment_1031: '请耐心等待',
    appointment_1032: '白名单',
    appointment_1033: '彩排已开始，请观看直播吧',
    appointment_1034: '提交手机号接收消息提醒',
    appointment_1035: '已预约'
  },
  nav: {
    nav_1001: '主办方',
    nav_1002: '公众号',
    nav_1003: '已关注',
    nav_1004: '关注',
    nav_1005: '登录',
    nav_1006: '我的直播',
    nav_1007: '财务中心',
    nav_1008: '我的主页',
    nav_1009: '账户设置',
    nav_1010: '退出',
    nav_1011: '退出登录',
    nav_1012: '关注公众号',
    nav_1013: '分享',
    nav_1014: '复制',
    nav_1015: '邀请卡',
    nav_1016: '微信',
    nav_1017: '微博',
    nav_1018: 'QQ',
    nav_1019: '使用微信“扫一扫”',
    nav_1020: '使用微信“扫一扫”  关注公众号',
    nav_1021: '长按识别二维码',
    nav_1022: '即可将活动分享至好友或朋友圈',
    nav_1023: '获得并转发自己的专属邀请卡',
    nav_1024: '复制成功',
    nav_1025: '点击查看更多详情',
    nav_1026: '微吼直播',
    nav_1027: '点击查看详情',
    nav_1028: '提现管理',
    nav_1029: '取消关注',
    nav_1030: '关注成功',
    nav_1031: '长按保存到本地',
    nav_1032: '邀请榜',
    nav_1033: '打赏榜',
    nav_1034: '排行榜规则',
    nav_1035: '打赏榜规则',
    nav_1036: '什么规则都没有',
    nav_1037: '邀请{n}人',
    nav_1038: '当前还没有人邀请，快去抢沙发吧~',
    nav_1039: '当前还没有人打赏，快去抢沙发吧~',
    nav_1040: '您还未邀请,快去抢沙发吧~',
    nav_1041: '土豪,求打赏!',
    nav_1042: '邀请好友观看',
    nav_1043: '已经到底啦~',
    nav_1044: '邀请你一起看直播',
    nav_1045: '立即参与活动',
    nav_1046: '扫/描/二/维/码',
    nav_1047: '长按保存图片后分享',
    nav_1048: '时间',
    nav_1049: '地点',
    nav_1050: '主播还未开启邀请哦',
    nav_1051: '支付宝',
    nav_1052: '复制失败',
    nav_1053: '主办方',
    nav_1054: '彩排下观众模拟观看地址',
    nav_1055: '彩排中',
    nav_1056: '商品已下架',
    nav_1057: '弹幕开',
    nav_1058: '弹幕关'
  },
  login: {
    login_1001: '账号登录',
    login_1002: '手机登录',
    login_1003: '验证码登录',
    login_1004: '密码登录',
    login_1005: '自动登录',
    login_1006: '立即登录',
    login_1007: '未登录',
    login_1008: '其他登录方式',
    login_1009: 'QQ登录',
    login_1010: '请输入手机号/邮箱',
    login_1011: '请输入登录密码',
    login_1012: '忘记密码',
    login_1013: '账号密码错误',
    login_1014: '请设置登录密码（6-30位字符）',
    login_1015: '登录信息获取失败，请重新登录',
    login_1016: '异常请求，无法操作',
    login_1017: '图形码未验证通过',
    login_1018: '请输入图形验证码',
    login_1019: '请输入您的手机号或邮箱',
    login_1020: '请输入您的账号密码',
    login_1021: '登录失败',
    login_1022: '请输入账号',
    login_1023: '图形验证码错误',
    login_1024: '密码有误请重新输入',
    login_1025: '密码不一致，请重新输入',
    login_1026: '去登录',
    login_1027: '同意并遵守《服务条款》',
    login_1028: '秒后发送',
    login_1029: '检测手机号失败',
    login_1030: '同意并遵守',
    login_1031: '《服务条款》',
    login_1032: '微信登录',
    login_1033: '找回密码',
    login_1034: '选择找回方式',
    login_1035: '验证身份',
    login_1036: '设置新密码',
    login_1037: '设置成功',
    login_1038: '通过手机找回',
    login_1039: '通过注册时填写的手机号找回',
    login_1040: '通过邮箱找回',
    login_1041: '通过注册时填写的邮箱找回',
    login_1042: '请填写您的注册手机号获取验证码，完成身份验证；您还可以选择',
    login_1043: '邮箱找回密码',
    login_1044: '请输入手机号',
    login_1045: '请输入验证码',
    login_1046: '获取验证码',
    login_1047: '请填写您的邮箱获取验证码，完成身份验证；您还可以选择',
    login_1048: '手机找回密码',
    login_1049: '请输入邮箱',
    login_1050: '请输入邮箱验证码',
    login_1051: '确认',
    login_1052: '请输入新密码',
    login_1053: '请再次输入密码',
    login_1054: '提交',
    login_1055: '新密码设置成功',
    login_1056: '请输入正确的手机号',
    login_1057: '请输入正确的邮箱',
    login_1058: '请再次输入密码',
    login_1059: '请先校验图形验证码',
    login_1060: '图形验证码错误'
  },
  register: {
    register_1001: '欢迎注册微吼直播',
    register_1002: '注册新用户',
    register_1003: '请先勾选协议',
    register_1004: '提交失败',
    register_1005: '立即注册',
    register_1006: '该手机号已注册',
    register_1007: '设置密码（选填，6-30个字符）',
    register_1008: '我已阅读并同意',
    register_1009: '注册成功',
    register_1010: '注册失败',
    register_1011: '服务条款及隐私协议',
    register_1012: '请先勾选“同意并遵守《服务条款》”',
    register_1013: '注册'
  },
  footer: {
    footer_1001: '反馈与举报',
    footer_1002: '问题分类',
    footer_1003: '观看问题',
    footer_1004: '内容举报',
    footer_1005: '卡顿',
    footer_1006: '黑屏',
    footer_1007: '声音不同步',
    footer_1008: '助手崩溃',
    footer_1009: '插入视频问题',
    footer_1010: '摄像设置问题',
    footer_1011: '音频问题',
    footer_1012: '软件共享源失败',
    footer_1013: '传播色情、暴力、反动等违法不良信息',
    footer_1014: '欺诈',
    footer_1015: '传销',
    footer_1016: '邪教',
    footer_1017: '描述',
    footer_1018: '内容不能大于1000个字符',
    footer_1019: '问题反馈成功',
    footer_1020: '请描述问题详情',
    footer_1021: '微吼提供技术支持'
  },
  chat: {
    chat_1001: '{n}后参与聊天',
    chat_1002: '{n}后提问',
    chat_1003: '快来提问吧',
    chat_1004: '输入想说的话',
    chat_1005: '内容不能大于140个字符',
    chat_1006: '您已被禁言',
    chat_1007: '您已被踢出房间',
    chat_1008: '您已被禁止访问房间',
    chat_1009: '内容不能为空',
    chat_1010: '发送成功',
    chat_1011: '发送失败',
    chat_1012: '只看主办方',
    chat_1013: '屏蔽特效',
    chat_1014: '已开启只看主办方',
    chat_1015: '已关闭只看主办方',
    chat_1016: '已屏蔽特效',
    chat_1017: '已开启特效',
    chat_1018: '只看我的',
    chat_1019: '已开启只看我的',
    chat_1020: '已关闭只看我的',
    chat_1021: '参与聊天',
    chat_1022: '主持人',
    chat_1023: '嘉宾',
    chat_1024: '助理',
    chat_1025: '发送太频繁啦~',
    chat_1026: '开启了{n}',
    chat_1027: '发起了签到',
    chat_1028: '结束了签到',
    chat_1029: '打赏了红包',
    chat_1030: '推送了问卷',
    chat_1031: '查看详情',
    chat_1032: '送出',
    chat_1033: '发送了红包',
    chat_1034: '有人',
    chat_1035: '有{n}条未读消息',
    chat_1036: '回复',
    chat_1037: '很精彩，赞一个～～',
    chat_1038: '红包派发中',
    chat_1039: '在直播中回答了这个问题',
    chat_1040: '提问',
    chat_1041: '回答',
    chat_1042: '说点什么',
    chat_1043: '参与互动',
    chat_1044: '全体禁言中',
    chat_1045: '输入私聊内容',
    chat_1056: '发送问答失败',
    chat_1057: '输入内容不能为空',
    chat_1058: '查看聊天历史消息',
    chat_1059: '你',
    chat_1060: '查看问卷',
    chat_1061: '送出一个',
    chat_1062: '未定义',
    chat_1063: '观众',
    chat_1064: '组长',
    chat_1065: '聊天图片加载失败',
    chat_1066: '输入问题',
    chat_1067: '{n}秒可以发言',
    chat_1068: '当前活动火爆，请您在{n}秒后再次发言',
    chat_1069: '最多140字',
    chat_1070: '观众{n}结束了演示',
    chat_1071: '主持人已将您分配至{n}组',
    chat_1072: '主持人开启了分组讨论，您将进入{n}组参与讨论',
    chat_1073: '主持人结束了分组讨论，您将返回主直播间',
    chat_1074: '主持人解散了分组，您将返回主直播间',
    chat_1075: '有人@你',
    chat_1076: '有人回复你',
    chat_1077: '悄悄回答你',
    chat_1078: '有新消息',
    chat_1079: '禁止发言',
    chat_1080: '太频繁啦，还有{n}秒后才能发送',
    chat_1081: '关闭了{n}',
    chat_1082: '文字回复',
    chat_1083: '在直播中回答',
    chat_1084: '更多',
    chat_1085: '不处理',
    chat_1086: '在直播中回答此问题',
    chat_1087: '已撤销',
    chat_1088: '撤销回复',
    chat_1089: '公开回答',
    chat_1090: '悄悄回答你',
    chat_1091: '处理时间',
    chat_1092: '禁止发言',
    chat_1093: '点击查看',
    chat_1094: '仅查看聊天内容',
    chat_1095: '聊天设置',
    chat_1096: '已开启仅查看聊天内容',
    chat_1097: '已关闭仅查看聊天内容',
    chat_1098: '点击查看',
    chat_1099: '推送了'
  },
  form: {
    form_1001: '姓名',
    form_1002: '地域',
    form_1003: '邮箱',
    form_1004: '请选择省份',
    form_1005: '请选择市',
    form_1006: '请选择区/县',
    form_1007: '请填写邮箱',
    form_1008: '请填写正确格式的邮箱',
    form_1009: '邮箱长度不能大于80',
    form_1010: '请填写正确的邮箱',
    form_1011: '展开',
    form_1012: '收起',
    form_1013: '隐私声明',
    form_1014: '请输入',
    form_1015: '男',
    form_1016: '女',
    form_1017: '请输入描述内容',
    form_1018: '请选择',
    form_1019: '报名',
    form_1020: '请输入验证码',
    form_1021: '发送验证码',
    form_1022: '请输入报名时您填写的手机号',
    form_1023: '请输入邮箱',
    form_1024: '我已报名',
    form_1025: '活动报名',
    form_1026: '请填写姓名',
    form_1027: '请选择性别',
    form_1028: '请填写内容',
    form_1029: '请选择内容',
    form_1030: '请先勾选隐私协议',
    form_1031: '报名表单基本信息失败',
    form_1032: '信息提交成功，直播将在{n}正式开始，请准时参加',
    form_1033: '您已报名，验证成功',
    form_1034: '请先报名',
    form_1035: '是',
    form_1036: '否',
    form_1037: '问卷已提交成功，感谢您的参与',
    form_1038: '请设置选项',
    form_1039: '选项不能为空',
    form_1040: '问卷标题不能为空',
    form_1041: '请输入选项',
    form_1042: '请输入详细地址',
    form_1043: '省/自治区/直辖市',
    form_1044: '区/县',
    form_1045: '提交',
    form_1046: '选择日期',
    form_1047: '选择日期+时间',
    form_1048: '选择时间',
    form_1049: '添加列选项',
    form_1050: '必填项',
    form_1051: '添加行选项',
    form_1052: '添加选项',
    form_1053: '请输入题目',
    form_1054: '公司',
    form_1055: '性别',
    form_1056: '职务',
    form_1057: '首席执行官/总经理',
    form_1058: '首席信息官/IT经理',
    form_1059: '市场总监/经理',
    form_1060: '销售总监/经理',
    form_1061: '技术总监/经理',
    form_1062: '工程技术人员',
    form_1063: '其他',
    form_1064: '手机',
    form_1065: '生日',
    form_1066: '行业',
    form_1067: '教育水平',
    form_1068: '单选题',
    form_1069: '多选题',
    form_1070: '问答题',
    form_1071: '下拉题',
    form_1072: '小节',
    form_1073: '标题',
    form_1074: '问卷',
    form_1075: '我们根据《隐私声明》保护您填写的所有信息',
    form_1076: '验证码',
    form_1077: '选项',
    form_1078: '报名表单',
    form_1079: '密码',
    form_1080: '最多可输入60个字',
    form_1081: '请输入报名时填写的手机号',
    form_1082: '验证',
    form_1083: '此项为必填项',
    form_1084: '请输入正确的整数',
    form_1085: '地址',
    form_1086: '输入关键词/用户昵称',
    form_1087: '提交成功，感谢您的参与',
    form_1088: '提交成功',
    form_1089: '填写',
    form_1090: '已填',
    form_1091: '我的礼品'
  },
  menu: {
    menu_1001: '文档',
    menu_1002: '聊天',
    menu_1003: '简介',
    menu_1004: '商品',
    menu_1005: '推荐',
    menu_1006: '优惠价',
    menu_1007: '购买',
    menu_1008: '商品详情',
    menu_1009: '访问店铺',
    menu_1010: '查看',
    menu_1011: '暂无图片',
    menu_1012: '默认图文',
    menu_1013: '章节',
    menu_1014: '视频',
    menu_1015: '音频'
  },
  interact_tools: {
    interact_tools_1001: '请输入抽奖标题',
    interact_tools_1002: '正在进行抽奖',
    interact_tools_1003: '抽奖',
    interact_tools_1004: '请输入地址',
    interact_tools_1005: '请输入姓名',
    interact_tools_1006: '领奖',
    interact_tools_1007: '发送{n}参与抽奖',
    interact_tools_1008: '立即参与',
    interact_tools_1009: '奖品',
    interact_tools_1010: '您与大奖擦肩而过',
    interact_tools_1011: '感谢您的参与',
    interact_tools_1012: '查看中奖名单',
    interact_tools_1013: '信息提交成功',
    interact_tools_1014: '信息提交失败',
    interact_tools_1015: '中奖啦',
    interact_tools_1016: '恭喜您获得',
    interact_tools_1017: '立即领奖',
    interact_tools_1018: '请填写领奖信息，方便主办方与您联系',
    interact_tools_1019: '提交',
    interact_tools_1020: '中奖名单',
    interact_tools_1021: '正在进行抽奖...',
    interact_tools_1022: '很遗憾，您没有中奖！',
    interact_tools_1023: '恭喜您中奖了！',
    interact_tools_1024: '签到',
    interact_tools_1025: '主持人发起了签到',
    interact_tools_1026: '立即签到',
    interact_tools_1027: '签到成功',
    interact_tools_1028: '签到失败',
    interact_tools_1029: '礼物',
    interact_tools_1030: '赠送',
    interact_tools_1031: '赠送成功',
    interact_tools_1032: '多谢大家支持',
    interact_tools_1033: '已存入个人账户',
    interact_tools_1034: '手慢了',
    interact_tools_1035: '红包抢光啦～',
    interact_tools_1036: '看看大家的手气',
    interact_tools_1037: '如何提现',
    interact_tools_1038: '微信登录的用户，可关注微吼公众号，在红包收益中提现',
    interact_tools_1039:
      '其他方式登录用户抢到的红包，请登录PC端后，在个人账户的，【提现管理】中进行提现操作',
    interact_tools_1040: '拼',
    interact_tools_1041: '普',
    interact_tools_1042: '最佳',
    interact_tools_1043: '领取{n}个',
    interact_tools_1044: '打赏',
    interact_tools_1045: '请选择打赏金额',
    interact_tools_1046: '打赏其他金额',
    interact_tools_1047: '很精彩，赞一个',
    interact_tools_1048: '支付方式',
    interact_tools_1049: '微信支付',
    interact_tools_1050: '支付',
    interact_tools_1051: '【扫一扫】付款',
    interact_tools_1052: '打开',
    interact_tools_1053: '超时，开始正向计时',
    interact_tools_1054: '倒计时',
    interact_tools_1055: '已暂停',
    interact_tools_1056: '已结束',
    interact_tools_1057: '进行中...',
    interact_tools_1058: '免费',
    interact_tools_1059: '咖啡',
    interact_tools_1060: '爱心',
    interact_tools_1061: '鼓掌',
    interact_tools_1062: '玫瑰',
    interact_tools_1063: '礼物赠送成功',
    interact_tools_1064: '请选择礼物',
    interact_tools_1065: '发送口令{n}参与抽奖吧',
    interact_tools_1066: '请填写',
    interact_tools_1067: '填写成功',
    interact_tools_1068: '提交问卷成功',
    interact_tools_1069: '支付宝支付',
    interact_tools_1070: '输入金额格式错误',
    interact_tools_1071: '打赏金额超出限制',
    interact_tools_1072: '二维码',
    interact_tools_1073: '打赏{n}',
    interact_tools_1074: '很遗憾',
    interact_tools_1075: '掌声',
    interact_tools_1076: '中奖记录',
    interact_tools_1077: '领取',
    interact_tools_1078: '已领取',
    interact_tools_1079: '已中奖',
    interact_tools_1080: '口令红包',
    interact_tools_1081: '支付宝搜“红包”，输入口令',
    interact_tools_1082: '一键复制口令',
    interact_tools_1083: '查看领取名单',
    interact_tools_1085: '领取Top10名单',
    interact_tools_1086: '公告',
    interact_tools_1087: '火箭',
    interact_tools_1088: '飞机',
    interact_tools_1089: '礼炮',
    interact_tools_1090: '汽车',
    interact_tools_1091: '领奖信息',
    interact_tools_1092: '中奖详情',
    interact_tools_1093: '本轮奖品 “{n}”',
    interact_tools_1094: '当前无中奖用户',
    interact_tools_1095: '您的姓名',
    interact_tools_1096: '手机号码',
    interact_tools_1097: '收货地址',
    interact_tools_1098: '红包',
    interact_tools_1099: '计时器'
  },
  setting: {
    setting_1002: '观看设置',
    setting_1003: '摄像头',
    setting_1004: '麦克风',
    setting_1005: '扬声器',
    setting_1006: '推流画面',
    setting_1007: '图片',
    setting_1008: '设备切换中，请稍后…',
    setting_1009: '默认视频流占位图',
    setting_1010: '摄像头切换失败，请稍后重试',
    setting_1011: '看不到摄像头画面？试试以下方法：',
    setting_1012: '请允许浏览器使用摄像头权限',
    setting_1013: '确认摄像头没有被其他程序占用',
    setting_1014: '选择外置摄像头或者更换电脑',
    setting_1015: ' 删除',
    setting_1016: '建议尺寸：1280*720px，小于2MB，支持jpg、png',
    setting_1017: '请选择麦克风',
    setting_1018: '对着麦克风讲话，看不到音量条波动？',
    setting_1019: '试试以下方法：',
    setting_1020: '请允许浏览器使用麦克风权限',
    setting_1021: '确认麦克风没有被其他程序占用',
    setting_1022: '选择外置麦克风或者更换电脑',
    setting_1023: '请选择扬声器',
    setting_1024: '点此播放声音',
    setting_1025: '点击播放键，听不到声音？试试以下方法：',
    setting_1026: '请允许浏览器使用声音权限',
    setting_1027: '请调高设备的扬声器音量',
    setting_1028: '选择外置扬声器或者更换电脑',
    setting_1029: '帮助与支持',
    setting_1030: '媒体设置',
    setting_1031: '修改设置后导致重新推流，是否继续保存',
    setting_1032: '摄像头检测',
    setting_1033: '暂无设备'
  },
  message: {
    message_1001: '主办方设置了视频加密功能，建议使用电脑访问观看',
    message_1002: '不支持视频加密提示',
    message_1003: '账号已在其他设备上观看该活动',
    message_1004: '此视频已下线！',
    message_1005: '此专题已下线！',
    message_1006: '该页面已停止提供服务',
    message_1007: '您已被禁止访问当前活动！',
    message_1008: '活动现场太火爆，已超过人数上限！',
    message_1009:
      '正在使用主持人、助理或嘉宾身份参加活动，无法观看。建议清除浏览器缓存后再进行访问~',
    message_1010: '网络正在开小差',
    message_1011: '当前IE浏览器版本较低，请升级至IE10及以上版本，推荐使用使用Chrome浏览器观看~',
    message_1012: '嵌入页面只支持3种验证方式：默认、密码、第三方K值！无法观看，请联系活动主办方',
    message_1013: '页面失联，攻城狮正赶来的路上…',
    message_1014: '视频转码中',
    message_1015: 'K 值验证失败，即将跳转',
    message_1016: '主持人、嘉宾或助理不允许进入观看端',
    message_1017: '当前版本不支持观看，请更换其他浏览器',
    message_1018: '主办方设置了视频加密功能，',
    message_1019: '建议使用电脑访问观看',
    message_1020: '活动不存在或已删除',
    message_1021: '不支持的活动类型(flash)',
    message_1022: '系统正在升级中…',
    message_1023: '00:00-07:00期间系统升级中，由此给您带来不便，敬请谅解！',
    message_1024: '您已在其他设备登录',
    message_1025: '如有问题请咨询链接提供方',
    message_1026: '获取信息失败',
    message_1027: '主持人刷新页面或者离开了页面，请稍等...',
    message_1028: '创建本地预览流失败',
    message_1029: '{n}离开房间',
    message_1030: '{n}加入房间',
    message_1031: '创建本地预览流失败,请检查设备',
    message_1032: '请输入必填信息：',
    message_1033: '邀请发送成功',
    message_1034: '邀请演示发送成功',
    message_1035: '为了保证更好的观看体验，请您竖屏观看'
  },
  cash: {
    cash_1001: '管理余额',
    cash_1002: '可提现金额',
    cash_1003: '元',
    cash_1004: '提现中',
    cash_1005: '提现',
    cash_1006: '当前余额不足1元，暂无法提现',
    cash_1007: '提现说明',
    cash_1008: '红包提现额度为多少？',
    cash_1009:
      '红包余额1元以上方可提现，线上最大支持单笔提现额度为800元。应国家税务局要求，个人用户单次提现超过800元将产生个人所得税，请发送以下资料至：finance@vhall.com',
    cash_1010: '个人用户：系统账号、姓名、身份证号、银行账户姓名、账号、开户行',
    cash_1011: '公司用户：系统账号、营业执照扫描件加盖公章银行账户名称、账号、开户行',
    cash_1012: '公司/个人信息与银行信息必须对应',
    cash_1013: '红包提现有手续费么，手续费具体为多少？',
    cash_1014: '无手续费',
    cash_1015: '提现申请后，几天内到账？',
    cash_1016: '从提现当天算起，7-15个工作日内到账，最终以实际到账时间为准',
    cash_1017: '提现还有什么其他注意事项？',
    cash_1018: '在提现周期内不能再次提现，到账后方可重新进行提现操作',
    cash_1019: '抢红包',
    cash_1020: '暂无账户变动记录',
    cash_1021: '当前账户无绑定手机号，为了您的资金安全，请首先完成手机号设置',
    cash_1022: '设置并继续提现',
    cash_1023: '请使用微信扫码，绑定您的收款账户',
    cash_1024: '绑定成功后将自动继续提现',
    cash_1025: '请输入提现金额',
    cash_1026: '到账微信',
    cash_1027: '立即提现',
    cash_1028: '提交即代表我已同意',
    cash_1029: '《用户兑换协议》',
    cash_1030: '请输入数字值',
    cash_1031: '提现金额最少1元',
    cash_1032: '提现值必须小于可用金额',
    cash_1033: '验证结果不成功，无法操作',
    cash_1034: '金额最多支持两位小数',
    cash_1035: '请在微信中打开并申请提现',
    cash_1036: '提现成功',
    cash_1037: '提现失败，无法操作',
    cash_1038: '验证码不能为空',
    cash_1039: '验证码错误',
    cash_1040: '检测用户是否绑定过提现账户失败'
  },
  account: {
    account_1001: '个人资料',
    account_1002: '手机号码',
    account_1003: '当前尚未完善手机号',
    account_1004: '更换',
    account_1005: '设置',
    account_1006: '昵称',
    account_1007: '保存',
    account_1008: '修改',
    account_1009: '头像',
    account_1010: '建议尺寸：140*140px',
    account_1011: '小于2M',
    account_1012: '支持jpg、gif、png、bmp',
    account_1013: '登录密码',
    account_1014: '已设置',
    account_1015: '未设置',
    account_1016: '修改密码',
    account_1017: '设置密码',
    account_1018: '绑定QQ',
    account_1019: '已绑定',
    account_1020: '未绑定',
    account_1021: '解除绑定',
    account_1022: '立即绑定',
    account_1023: '绑定微信',
    account_1024: '设置手机号',
    account_1025: '请输入手机号',
    account_1026: '修改绑定手机号',
    account_1027: '完善手机号',
    account_1028: '图形码错误',
    account_1029: '动态验证码',
    account_1030: '获取验证码',
    account_1031: '{n}s',
    account_1032: '第一步：验证原有手机号',
    account_1033: '为了保证您的账号安全，修改手机号前请先验证已绑定的手机号',
    account_1034: '第二步：设置新手机号',
    account_1035: '立即设置',
    account_1036: '下一步',
    account_1037: '完成',
    account_1038: '设置一个新的登录密码',
    account_1039: '输入旧的登录密码',
    account_1040: '输入新密码',
    account_1041: '输入登录密码',
    account_1042: '重复输入新密码',
    account_1043: '重复输入登录密码',
    account_1044: '上传封面图片只能是png格式',
    account_1045: '上传封面图片大小不能超过 2MB',
    account_1046: '封面上传失败',
    account_1047: '头像修改成功',
    account_1048: '头像修改失败',
    account_1049: '请输入您的手机号',
    account_1050: '手机号格式不正确',
    account_1051: '发送验证码失败',
    account_1052: '手机号验证失败，无法操作',
    account_1053: '绑定成功',
    account_1054: '绑定失败',
    account_1055: '昵称不能为空',
    account_1056: '昵称长度1-30字符',
    account_1057: '昵称修改成功',
    account_1058: '昵称修改失败',
    account_1059: '操作成功',
    account_1060: '解绑 QQ 后你将无法使用 QQ 登录，你确定要解绑吗？',
    account_1061: '提示',
    account_1062: '确定',
    account_1063: '取消',
    account_1064: '解绑成功',
    account_1065: '解绑失败',
    account_1066: '解绑 微信 后你将无法使用 微信 登录，你确定要解绑吗？',
    account_1067: '封面',
    account_1068: '删除',
    account_1069: '请输入正确的手机号',
    account_1070: '请输入动态验证码',
    account_1071: '请输入密码！',
    account_1072: '6-30位不包含空格及特殊符号的密码！',
    account_1073: '请再次输入密码！',
    account_1074: '两次输入密码不一致',
    account_1075: '修改个人资料',
    account_1076: '移除',
    account_1077: '上一步',
    account_1078: '该微信已被绑定，请先解绑',
    account_1079: '该QQ已被绑定，请先解绑'
  },
  interact: {
    interact_1001: '举手上麦',
    interact_1002: '主持人关闭了举手功能',
    interact_1003: '您可以举手申请上麦了',
    interact_1004: '等待',
    interact_1005: '关闭麦克风',
    interact_1006: '关闭摄像头',
    interact_1007: '下麦',
    interact_1008: '主持人邀请您上麦',
    interact_1009: '同意',
    interact_1010: '拒绝',
    interact_1011: '因设备问题导致连麦中断，请检查设备',
    interact_1012: '{n}设置成为{m}',
    interact_1013: '因网络问题订阅桌面共享失败，正在重新订阅',
    interact_1014: '因网络问题订阅用户{n}失败，正在重新订阅',
    interact_1015: '打开麦克风',
    interact_1016: '初始化本地流失败，请检查设备是否被禁用或者被占用',
    interact_1017: '请先开启上麦',
    interact_1018: '下麦成功',
    interact_1019: '当前浏览器或浏览器版本不支进行互动，请升级最新版本或者更换chrome浏览器',
    interact_1020: '或',
    interact_1021: '推流失败',
    interact_1022: '打开摄像头',
    interact_1023: '摄像头已关闭，对方将看不到您的画面',
    interact_1024: '摄像头已打开',
    interact_1025: '由于您长时间没有响应，导致上麦失败',
    interact_1026: '麦克风已关闭，对方将听不到您的声音',
    interact_1027: '您已取消申请上麦！',
    interact_1028: '您已下麦',
    interact_1029: '上麦席位已满员，您的账号支持{n}人上麦',
    interact_1030: '{n}已下麦',
    interact_1031: '{n}邀请您上麦',
    interact_1032: '麦克风开启，对方将听到您的声音',
    interact_1033: '主画面',
    interact_1034: '主讲人',
    interact_1035: '对方网络异常',
    interact_1036: '因网络问题导致直播中断，请刷新页面重连',
    interact_1037: '您正在轮巡中，暂不能申请上麦，请稍后再试',
    interact_1038:
      '主办方开启了视频轮巡功能，在主持人端将会看到您的视频画面，请保证视频设备一切正常，点击“{n}”进行媒体设置',
    interact_1039: '只有获取摄像头和麦克风权限后，才能参与连麦',
    interact_1040: '参与连麦需获取摄像头和麦克风权限，前往浏览器设置中心开启权限',
    interact_1041: '申请连麦',
    interact_1042: '检查设备',
    interact_1043: '您确定要下麦吗'
  },
  doc: {
    doc_1001: '文档加载中',
    doc_1002: '主讲人未添加文档，请稍等...',
    doc_1003: '主讲人正在准备文档，请稍等…',
    doc_1004: '文档不存在或已删除',
    doc_1005: '放大',
    doc_1006: '缩小',
    doc_1007: '移动',
    doc_1008: '还原',
    doc_1009: '退出全屏',
    doc_1010: '全屏',
    doc_1011: '暂未分享任何文档',
    doc_1012: '选择文档',
    doc_1013: '观众可见',
    doc_1014: '文档缩略图',
    doc_1015: '资料库',
    doc_1016: '选择',
    doc_1017: '橡皮擦',
    doc_1018: '画笔',
    doc_1019: '荧光笔',
    doc_1020: '形状',
    doc_1021: '文本',
    doc_1022: '清除',
    doc_1023: '圆形',
    doc_1024: '四边形',
    doc_1025: '单向箭头',
    doc_1026: '双向箭头',
    doc_1027: '上传',
    doc_1028: '取消移动',
    doc_1029: '直播准备中，敬请期待'
  },
  webinar: {
    webinar_1001: '关闭',
    webinar_1002: '啊哦，抢光了～',
    webinar_1003: '已存入到您的微吼账户',
    webinar_1004: '微信登录用户，可点击聊天区域左下角头像，在提现管理中提现',
    webinar_1005:
      '其他方式登录的用户，请复制观看链接到电脑浏览器，登录后点击右上角头像，在提现管理中提现',
    webinar_1006: '暂无数据',
    webinar_1007: '倒计时已暂停',
    webinar_1008: '倒计时已结束',
    webinar_1009: '倒计时进行中...',
    webinar_1010: '发送',
    webinar_1011: '输入想说的话…',
    webinar_1012: '重复签到',
    webinar_1013: '复制淘口令',
    webinar_1014: '长按复制淘口令内容，使用淘宝App购买或使用浏览器打开查看',
    webinar_1015: '进入活动',
    webinar_1016: '只能通过PC端进入',
    webinar_1017: '直播进行中',
    webinar_1018: '直播中',
    webinar_1019: '直播提醒',
    webinar_1020: '进入房间',
    webinar_1021: '观看点播',
    webinar_1022: '观看回放',
    webinar_1023: '进入直播',
    webinar_1024: '付费预约',
    webinar_1025: '绑定手机号码，以便开播开始前接收短信提醒，不再错过精彩直播',
    webinar_1026: '您已在其他设备登录',
    webinar_1027: '凌晨',
    webinar_1028: '早上',
    webinar_1029: '下午',
    webinar_1030: '晚上',
    webinar_1031: '继续观看',
    webinar_1032: '点击刷新',
    webinar_1033: '手机扫码观看',
    webinar_1034: '二维码加载失败',
    webinar_1035: '打开微信，点击底部的“发现”，使用 “扫一扫” 即可将网页分享到我的朋友圈。',
    webinar_1036: '密码活动',
    webinar_1037: '游客***',
    webinar_1038: '分享成功',
    webinar_1039: '预约',
    webinar_1040: '付费{n}预约',
    webinar_1041: '付费{n}观看',
    webinar_1042: '暂未搜索到您想要的内容'
  },
  color: {
    color_1001: '白色',
    color_1002: '浅灰',
    color_1003: '深灰',
    color_1004: '黑色',
    color_1005: '红色',
    color_1006: '橙色',
    color_1007: '黄色',
    color_1008: '绿色',
    color_1009: '青色',
    color_1010: '蓝色',
    color_1011: '紫色',
    color_1012: '粉色'
  },
  other: {
    other_1001: '预览图',
    other_1002: '输入密码',
    other_1003: '输入邀请码',
    other_1004: '上传图片大小不能超过 2MB',
    other_1005: '请求协助发送成功',
    other_1006: '主持人未响应您的上麦申请',
    other_1007: '试试左右滑动',
    other_1008: '等待中',
    other_1009: '本场直播支持视频连线，建议您允许系统启用相应设备以使用该功能。',
    other_1010: '当前设备不支持连麦',
    other_1011: '允许“webinar.e.vhall.com”使用您的摄像头和麦克风？',
    other_1012: '不允许',
    other_1013: '允许',
    other_1014: '设备检测',
    other_1015: '我知道了',
    other_1016: 'k 值验证失败',
    other_1017: '同意并继续',
    other_1018: '拒绝',
    other_1019: '知道了',
    other_1020: '很遗憾无法继续为您提供服务，您可以手动关闭页面',
    other_1021: '注：嘉宾、助理通过正式直播地址参与彩排',
    other_1022: '微吼直播 ',
    other_1023: '申请',
    other_1024: '获取您的微信昵称、头像信息',
    other_1025: '用于观看直播参与聊天、抽奖、抢红包等互动行为',
    other_1026: '微信授权 ',
    other_1027: '确定',
    other_1028: '取消'
  },
  privacy: {
    privacy_1001: '阅读并同意{n}及{n1}',
    privacy_1002: '提交即同意{n}及{n1}',
    privacy_1003: '《用户保护协议》',
    privacy_1004: '《隐私政策》',
    privacy_1005: '请先阅读并同意隐私政策及用户服务协议',
    privacy_1006: '提交即同意《隐私政策》及《用户保护协议》',
    privacy_1007: '请先勾选协议'
  },
  exam: {
    exam_1001: '发起快问快答 ',
    exam_1002: '参与答题',
    exam_1003: '公布',
    exam_1004: '成绩排行榜',
    exam_1005: '剩余时间',
    exam_1006: '不限时',
    exam_1007: '正在作答',
    exam_1008: '太棒了，全部答对了！',
    exam_1009: '很遗憾，回答错误，继续努力！',
    exam_1010: '很遗憾，您已错过本次答题机会！',
    exam_1011: '查看答题',
    exam_1012: '正在查看',
    exam_1013: '分数',
    exam_1014: '正确答案',
    exam_1015: '您的答案',
    exam_1016: '正确',
    exam_1017: '错误',
    exam_1018: '未作答',
    exam_1019: '上一题',
    exam_1020: '下一题',
    exam_1021: '成绩统计中，请耐心等待',
    exam_1022: '快问快答列表',
    exam_1023: '推送时间',
    exam_1024: '限时',
    exam_1025: '总分',
    exam_1026: '题数',
    exam_1027: '答题',
    exam_1028: '已结束',
    exam_1029: '答对',
    exam_1030: '答错',
    exam_1031: '未答',
    exam_1032: '本次答题已结束， 点击查看',
    exam_1033: '查看完整榜单',
    exam_1034: '用户',
    exam_1035: '正确率',
    exam_1036: '答题用时',
    exam_1037: '我的排名',
    exam_1038: '第 {n} 名',
    exam_1039: '数据正在加载中...',
    exam_1040: '快问快答已结束',
    exam_1041: '结束快问快答',
    exam_1042: '满分',
    exam_1043: '0分',
    exam_1044: '工号',
    exam_1045: '最多展示前200名成绩',
    exam_1046: '无',
    exam_1047: '快问快答',
    exam_1048: '得分',
    exam_1049: '用时',
    exam_1050: '申请'
  }
};
